import React from "react";
import { useNavigate } from "react-router";
import { CallbackComponent } from "redux-oidc";
import userManager from "@utils/userManager";
import AjaxLoader from "@components/shared/ajax_loader";

interface ILoginPageProps extends React.ComponentProps<"div"> {}

function LoginPage(
  props: ILoginPageProps
): React.ReactElement<ILoginPageProps> {
  // just redirect to '/' in both cases
  const navigate = useNavigate();
  return (
    <CallbackComponent
      userManager={userManager}
      successCallback={() => {
        navigate("/atendimento");
      }}
      errorCallback={(error) => {
        navigate("/");
        console.error(error);
      }}
    >
      <AjaxLoader />
    </CallbackComponent>
  );
}

export default LoginPage;
